<div [formGroup]="form" class="p-d-flex p-flex-column p-fluid filters">
  <div class="p-d-flex p-flex-wrap " style="justify-content: space-between;">
    <div style="display: flex; " class="gap-8">
      <!-- Datum -->
      <div class="flex-1" *ngIf="tipIzvestaja == tip.DNEVNI_IZVESTAJ">
        <kodit-field fieldLabel="Datum: " fieldLabelFor="datum">
          <kodit-calendar
            [formCtrl]="form.controls.datum!"
            formCtrlId="datum"
          ></kodit-calendar>
        </kodit-field>
      </div>
      <!-- Datum  od -->
      <div
        class="flex-1"
        *ngIf="tipIzvestaja == tip.PERIODICNI_IZVESTAJ || tipIzvestaja == tip.PERIODICNI_KASIR || tipIzvestaja == tip.IZVESTAJ_PO_ARTIKLIMA || tipIzvestaja == tip.ONLINE_PRODAJA || tipIzvestaja == tip.PRODAJA_PO_MAGACINIMA"
      >
        <kodit-field fieldLabel="Datum od: " fieldLabelFor="datumOd">
          <kodit-calendar
            [formCtrl]="form.controls.datumOd!"
            formCtrlId="datumOd"
            [showTime]="true"
            (onSelect)="onDatumOdChange($event)"
          ></kodit-calendar>
        </kodit-field>
      </div>
      <!-- Datum izdavanja do -->
      <div
        class="flex-1"
        *ngIf="tipIzvestaja == tip.PERIODICNI_IZVESTAJ || tipIzvestaja == tip.PERIODICNI_KASIR || tipIzvestaja == tip.IZVESTAJ_PO_ARTIKLIMA || tipIzvestaja == tip.ONLINE_PRODAJA || tipIzvestaja == tip.PRODAJA_PO_MAGACINIMA"
      >
        <kodit-field fieldLabel="Datum do: " fieldLabelFor="datumDo">
          <kodit-calendar
            [formCtrl]="form.controls.datumDo!"
            formCtrlId="datumDo"
            [showTime]="true"
            (onSelect)="onDatumDoChange($event)"
          ></kodit-calendar>
        </kodit-field>
      </div>
      <!-- Magacini -->
      <div class="flex-1" *ngIf="tipIzvestaja == tip.PRODAJA_PO_MAGACINIMA">
        <kodit-field fieldLabel="Magacin: " fieldLabelFor="magacinIds">
          <p-multiSelect
            [options]="magacinOptions"
            [(ngModel)]="izabraniMagacinIds"
            [ngModelOptions]="{ standalone: true }"
            placeholder="Izaberite magacine"
            selectedItemsLabel="Izabrano magacina: {0}"
            [maxSelectedLabels]="2"
            id="magacinIds"
          ></p-multiSelect>
        </kodit-field>
      </div>
      <!-- Kasir -->
      <div class="flex-1" *ngIf="tipIzvestaja == tip.PERIODICNI_KASIR">
        <kodit-field fieldLabel="Kasir: " fieldLabelFor="kasir">
          <kodit-korisnik-autocomplete
            (onKorisnikChange)="handleKorisnikChange($event)"
            formCtrlId="kasirId"
            (onKasirClear)="onClear()"
            [jeIzvestaj]="true"
          ></kodit-korisnik-autocomplete>
        </kodit-field>
      </div>
    </div>
    <div style="display: flex; align-items: center">
      <kodit-button
        class="p-d-flex p-align-end"
        btnLabel="Primeni"
        btnIcon="fa-regular fa-magnifying-glass"
        (btnClicked)="primeniFilter()"
      ></kodit-button>
    </div>
  </div>
</div>
